import {
  madBuyLineItemWeekDays,
  type MadBuyLineItemDayTimeActivity,
  type MadBuyLineItemWeekDay,
} from './lineItemsCoreModel';

export function toggleMadBuyLineItemScheduleHour(
  activities: MadBuyLineItemDayTimeActivity[],
  day: MadBuyLineItemWeekDay,
  hour: number,
) {
  const selectedHours = new Set(expandDayTimeActivities(activities, day));
  if (selectedHours.has(hour)) {
    selectedHours.delete(hour);
  } else {
    selectedHours.add(hour);
  }

  return [
    ...activities.filter((activity) => activity.day !== day),
    ...collapseScheduleHours(day, Array.from(selectedHours)),
  ];
}

export function isMadBuyLineItemScheduleHourSelected(
  activities: MadBuyLineItemDayTimeActivity[],
  day: MadBuyLineItemWeekDay,
  hour: number,
) {
  return expandDayTimeActivities(activities, day).includes(hour);
}

const madBuyLineItemWeekDaySet: ReadonlySet<string> = new Set(madBuyLineItemWeekDays);

export function normalizeDayTimeActivities(
  activities: MadBuyLineItemDayTimeActivity[] | undefined,
): MadBuyLineItemDayTimeActivity[] {
  return (activities ?? [])
    .filter(
      (activity) =>
        madBuyLineItemWeekDaySet.has(activity.day) &&
        Number.isInteger(activity.startHour) &&
        Number.isInteger(activity.endHour) &&
        activity.startHour >= 0 &&
        activity.endHour >= activity.startHour &&
        activity.endHour <= 23,
    )
    .map((activity) => ({
      day: activity.day,
      restrictedHours: true,
      startHour: activity.startHour,
      endHour: activity.endHour,
    }));
}

function expandDayTimeActivities(
  activities: MadBuyLineItemDayTimeActivity[],
  day: MadBuyLineItemWeekDay,
) {
  const hours = new Set<number>();
  activities
    .filter((activity) => activity.day === day)
    .forEach((activity) => {
      for (let hour = activity.startHour; hour <= activity.endHour; hour += 1) {
        hours.add(hour);
      }
    });

  return Array.from(hours).sort((left, right) => left - right);
}

function collapseScheduleHours(day: MadBuyLineItemWeekDay, hours: number[]) {
  const normalizedHours = Array.from(new Set(hours))
    .filter((hour) => Number.isInteger(hour) && hour >= 0 && hour <= 23)
    .sort((left, right) => left - right);
  const ranges: MadBuyLineItemDayTimeActivity[] = [];
  let rangeStart: number | undefined;
  let previousHour: number | undefined;

  normalizedHours.forEach((hour) => {
    if (rangeStart === undefined || previousHour === undefined || hour !== previousHour + 1) {
      if (rangeStart !== undefined && previousHour !== undefined) {
        ranges.push({ day, restrictedHours: true, startHour: rangeStart, endHour: previousHour });
      }
      rangeStart = hour;
    }
    previousHour = hour;
  });

  if (rangeStart !== undefined && previousHour !== undefined) {
    ranges.push({ day, restrictedHours: true, startHour: rangeStart, endHour: previousHour });
  }

  return ranges;
}
